import React from 'react';
import { Title } from '@gerdau/hefesto';

import { EmptyCatalogContainer } from './style';
import { Button } from '@gerdau/hefesto';
import { SearchOptionsProps } from '../../../../../services/MVP/models';

type Props = {
  handleSearchChange: (
    value: SearchOptionsProps['filters'],
    noChanges?: boolean
  ) => Promise<void | null>;
};

export const EmptyCatalog = ({ handleSearchChange }: Props) => {
  const handleClearFilters = async () => {
    await handleSearchChange({
      materialCode: 'gerdauCode',
      ordenation: 'R',
      productsTypes: [],
      input: ''
    });
  };

  return (
    <EmptyCatalogContainer>
      <Title level={3}>
        Nenhum produto encontrado para os filtros selecionados.
      </Title>
      <Button
        onClick={handleClearFilters}
        name="clean-all-filters"
        variant="tertiary"
        fullWidth
      >
        Limpar todos os filtros
      </Button>
    </EmptyCatalogContainer>
  );
};
